/**
 *
 * @param {*要转为URL参数字符串的对象} param
 * @param {*是否进行URL编码，默认为false} encode
 * @param {*URL参数字符串的前缀} key
 * @description 将对象转为url参数字符串
 */
const urlEncode = (param: any, encode?: boolean, key?: string | number) => {
  if (param == null)
    return ''
  let paramStr = ''
  const t = typeof param
  if (['string', 'number', 'boolean'].includes(t)) {
    paramStr += `&${key}=${encode ? encodeURIComponent(param) : param}`
  }
  else {
    Object.keys(param).forEach((i: string | number) => {
      const k = key
        ? key + (Array.isArray(param) ? `[${i}]` : `.${i}`)
        : i
      paramStr += urlEncode(param[i], encode, k)
    })
  }
  return paramStr
}

export default urlEncode
